/**
 * Manifest Agent — thin wrapper over the shared AgentChatPanel.
 * All chat/stream/queue/artifact behavior lives in src/components/agent-chat/;
 * this file only supplies the flight-manifests tool configuration.
 */
import { AgentChatPanel, type AgentChatToolConfig } from '@/components/agent-chat/AgentChatPanel';

const CONFIG: AgentChatToolConfig = {
	tool: 'flight-manifests',
	title: (eventName) => `${eventName} — Manifest Agent`,
	headerDescription: 'Upload flight PDFs and work with the Flight Manifest Manager in plain language.',
	backLabel: 'Back to manifests',
	composerPlaceholder: 'Message the Manifest Agent…',
	agentDisplayName: 'Manifest Agent',
	splitStorageKey: 'manifest-agent-split',
	emptyStateHint: <>Drop flight itinerary PDFs here or ask a question — for example &ldquo;How many passengers arrive on the 21st?&rdquo;</>,
	dropLabel: 'Drop flight PDFs or screenshots here',
	boardPlaceholder: 'The agent keeps its live status board here: batch progress, anything waiting on you, and what was just finished.',
};

export function ManifestAgentPanel({ eventId, onClose }: { eventId: string; onClose: () => void }) {
	return <AgentChatPanel eventId={eventId} onClose={onClose} config={CONFIG} />;
}
